/* Keeps the drawer reward bar in step with the cart.

   Impulse replaces the [data-products] block wholesale on every cart change and
   stamps the new total on .cart__items[data-cart-subtotal] (in cents). Watching
   that node is therefore enough — no cart API polling, and it works for the
   drawer and the cart page alike. */
(function () {
  var root = document.getElementById('TcReward');
  if (!root) return;

  var threshold = parseInt(root.getAttribute('data-threshold'), 10) || 0;
  var fill = root.querySelector('.tc-reward__fill');
  var text = root.querySelector('.tc-reward__text');
  var tplAway = root.getAttribute('data-text-away') || '';
  var tplDone = root.getAttribute('data-text-done') || '';
  var fmt = root.getAttribute('data-money-format') || '${{amount}}';

  function money(cents) {
    var v = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/, v)
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }

  function render(total) {
    if (!threshold) return;
    var pct = Math.max(0, Math.min(100, (total / threshold) * 100));
    fill.style.width = pct + '%';
    var left = threshold - total;
    if (left <= 0) {
      root.classList.add('tc-reward--complete');
      text.innerHTML = tplDone;
    } else {
      root.classList.remove('tc-reward--complete');
      text.innerHTML = tplAway.replace('[amount]', '<strong>' + money(left) + '</strong>');
    }
  }

  function read() {
    var el = document.querySelector('.cart__items[data-cart-subtotal]');
    if (el) render(parseInt(el.getAttribute('data-cart-subtotal'), 10) || 0);
  }

  read();
  var host = document.querySelector('[data-products]');
  if (host && window.MutationObserver) {
    new MutationObserver(read).observe(host, { childList: true, subtree: true });
  }
  document.addEventListener('cart:updated', read);
})();

/* Discount code field.

   Shopify's AJAX cart API cannot apply a discount code — codes are a checkout
   concept. Hitting /discount/<code> sets the discount cookie, which checkout
   then honours. So we confirm acceptance here and let checkout show the money.
   An invalid code makes that endpoint redirect to the storefront 404. */
(function () {
  var input = document.getElementById('TcDiscountCode');
  var btn = document.getElementById('TcDiscountApply');
  var msg = document.getElementById('TcDiscountMsg');
  if (!input || !btn || !msg) return;

  function apply() {
    var code = (input.value || '').trim();
    if (!code) return;
    btn.disabled = true;
    msg.className = 'tc-discount__msg';
    msg.textContent = '…';
    fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', {
      credentials: 'same-origin'
    })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
      .then(function (body) {
        var looksLikeCart = body.indexOf('"item_count"') !== -1;
        msg.className = 'tc-discount__msg ' + (looksLikeCart ? 'tc-discount__msg--ok' : 'tc-discount__msg--err');
        msg.textContent = looksLikeCart
          ? 'Code accepted — applied at checkout.'
          : 'That code is not valid.';
        if (looksLikeCart) input.value = '';
      })
      .catch(function () {
        msg.className = 'tc-discount__msg tc-discount__msg--err';
        msg.textContent = 'That code is not valid.';
      })
      .then(function () { btn.disabled = false; });
  }

  btn.addEventListener('click', apply);
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') { e.preventDefault(); apply(); }
  });
})();
